import { useEffect, useState } from 'react';
import { useSelector,useDispatch  } from 'react-redux'
import UserVideoView from './UserVideoView';
import RejoinButton from '../helperforall/RejoinButton';
import UserToolsView from './UserToolsView';
import UserToolsViewSmall from './UserToolsViewSmall';
import { Grid,Container, Modal, Button} from '@mantine/core';
import intl from 'react-intl-universal';
import { set_userclick } from '../slice/mainslice';

/**
 * Renders the UserDash component.
 * 
 * Switch between CMS View and Rejoin Link
 * Switch between Full Usertool View and Reduce Usertool View
 * Handles the SignalR Listeners
 * 
 * @displaytyp: number - state.user.displaytyp - The current display type.
 * @meuser: {Object} - state.user.meuser - The current user.
 * @leftmeeting: {boolean} - state.user.leftmeeting - Status of User in Meeting.
 * @cmslink: {string} - state.user.cmslink - The cuurrent CMS link.
 * 
 * @return {JSX.Element} The rendered UserDash component.
 * 
 */

const UserDash = () => {
const dispatch = useDispatch()
const displaytyp: number = useSelector((state: any) => state.user.displaytyp )
const meuser = useSelector((state: any) => state.user.meuser)
const leftmeeting = useSelector((state: any) => state.user.leftmeeting)
const cmslink = useSelector((state: any) => state.user.cmslink)
const [opentool, setOpentool] = useState(true);
const [opened, setOpened] = useState(false);

const help_audio_clicked = useSelector((state: any) => state.user.help_audio_clicked)
const changelanguage = useSelector((state: any) => state.user.changelanguage)

let vidwidth = 9
let toolwidth = 3

if (!opentool){
  vidwidth = 11
  toolwidth = 1
}

if (opentool){
  vidwidth = 9
  toolwidth = 3
}

let joinlink = cmslink.joinLink
 
useEffect(() => {
const signalrActions = [ 
  { type: 'SIGNALR_RECIVE_USERISOK', eventName: "OnRequestMeetingLink"},
  { type: 'SIGNALR_UPDATE_USERDATA', eventName: "OnChangeParticipantStatus_" + meuser.userId },
  { type: 'SIGNALR_CHANGEMEETING_STATUSUSER', eventName: "OnChangeParticipantStatus_" + meuser.userId },
  { type: 'SIGNALR_RECIVE_ONUPDATEMEETINGANDPARTICIPANTSDATA', eventName: "OnUpdateMeetingAndParticipantsData" },
  { type: 'SIGNALR_ALLLEFT_STATUSUSER', eventName: "OnAllLeft" },
  { type: 'SIGNALR_CONFIRM_USERDATA', eventName: "OnConfirmUserIdentity" },
  { type: 'SIGNALR_RECIVEREJOINMEETINGLINK', eventName: "OnGetCapsuleLink" },
  { type: 'SIGNALR_RECIVEOPENDOC', eventName: "OnOpenDocumentForSign" },
  { type: 'SIGNALR_RECIVECONFDOC', eventName: "OnConfirmUserSignature" },
  { type: 'SIGNALR_RECIVEONHANDLEDOCUMENT', eventName: "OnHandleDocument" },
  { type: 'SIGNALR_RECIVE_ONPREPAREDOCUMENTS', eventName: "OnPrepareDocuments" },
  { type: 'SIGNALR_UPDATEMEETINGDATA', eventName: "OnUpdateMeetingDate" },
  { type: 'SIGNALR_RECIVE_ALIAS_DATA', eventName: "OnChangeNotarFirstAndLastName" },
  { type: 'SIGNALR_ON ARCHIVEDMEETING', eventName: "OnArchivedMeeting" },
  { type: 'SIGNALR_RECIVEONINVITEGURSTFROMVK', eventName: "OnInviteGuestFromVk" },
  { type: 'SIGNALR_ONBLOCKGUESTFROMVK', eventName: "OnBlockGuestFromVk" },
  { type: 'SIGNALR_RECIVE_PARTICIPANTSTOBEIDENTIFIED', eventName: "OnSetParticipantsToBeIdentified" },
  { type: 'SIGNALR_RECIVEOPENDOC_STAPEL', eventName: "OnOpenCloseStapelForSign" },
  { type: 'SIGNALR_RECIVE_ONDELETELOGGEDINPARTICIPANT', eventName: "OnDeleteLoggedInParticipant" },
  { type: 'SIGNALR_RECIVE_OC_DOCUMENT_SL_STAPEL', eventName: "OnOpenCloseStapelSharedLink" },
  { type: 'SIGNALR_RECIVE_OC_DOCUMENT_SL', eventName: "OnOpenCloseDocumentSharedLink" },
  { type: 'SIGNALR_RECIVE_ONUPDATE_SIGS_STATUSUPDATE', eventName: "OnDocumentSignatureStatusUpdate" }, 
  { type: 'SIGNALR_ONUPDATESTAPELSIGNATURE', eventName: "OnUpdateStapelSignature" },
];

signalrActions.forEach(action => {
  dispatch({ type: action.type, eventName: action.eventName });
});

// eslint-disable-next-line react-hooks/exhaustive-deps
},[]);


useEffect(() => {
  if (!help_audio_clicked) {
    setOpened(true);    
  }
},[help_audio_clicked]);

const handleCloseAudioHelp = () => {
  setOpened(false);
  
  
};

const confirmCloseAudioHelp = () => {
  setOpened(false);
  dispatch(set_userclick())
};

console.log(help_audio_clicked)
 
return (
  <>
    {displaytyp  === 1 &&
      <Container fluid>    
        <Grid >
          <Grid.Col xs={vidwidth} > 
                {!leftmeeting && joinlink && help_audio_clicked &&    
                  <UserVideoView />
                } 
                {changelanguage && joinlink === undefined &&
                  <RejoinButton />
                }
                {leftmeeting && joinlink === undefined && !changelanguage &&
                  <RejoinButton />
                }
          </Grid.Col>
          <Grid.Col xs={toolwidth}  > 
                {opentool &&
                  <UserToolsView setOpentool={setOpentool}/>
                }
                {!opentool &&
                  <UserToolsViewSmall setOpentool={setOpentool}/>
                }
         </Grid.Col>  
        </Grid>
      </ Container>
    }

<Modal
        title=""
        opened={opened}
        onClose={handleCloseAudioHelp}
        closeOnClickOutside={false}
        withCloseButton={false}
        size="md"
        shadow="sm"
        centered
        >
          {intl.get('WELCOME_MODAL_HEAD')} {meuser.firstName} {meuser.lastName}! 
          <hr />
          <Grid>
          <Grid.Col span={12}>
            <Button fullWidth color="green" onClick={confirmCloseAudioHelp}>{intl.get('WELCOME_MODAL_BUTTON')}</Button>
            </Grid.Col>
          </Grid>
      </Modal> 
  </> 
  );
}

export default UserDash;